export default __webpack_public_path__ + "b139983e3f8d69dbfe5298006f77bdae.png";